//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function externalDataSourcesGetList(config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfExternalDataSourceDto> {
    let url_ = getBaseUrl() + "/api/external/data-sources";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalDataSourcesGetList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExternalDataSourcesGetList?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalDataSourcesGetList(_response);
    });
}

function processExternalDataSourcesGetList(response: AxiosResponse): Promise<Types.ListResultDtoOfExternalDataSourceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfExternalDataSourceDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfExternalDataSourceDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalDataSourcesSetEnabled(dataSource: Types.DataSource, body?: Types.ExternalDataSourceSetEnabledInput | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/external/data-sources/{dataSource}";
    if (dataSource === undefined || dataSource === null)
      throw new Error("The parameter 'dataSource' must be defined.");
    url_ = url_.replace("{dataSource}", encodeURIComponent("" + dataSource));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalDataSourcesSetEnabled,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigExternalDataSourcesSetEnabled?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalDataSourcesSetEnabled(_response);
    });
}

function processExternalDataSourcesSetEnabled(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalDataSourcesSetPriority(dataSource: Types.DataSource, body?: Types.ExternalDataSourceSetPriorityInput | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/external/data-sources/{dataSource}/priority";
    if (dataSource === undefined || dataSource === null)
      throw new Error("The parameter 'dataSource' must be defined.");
    url_ = url_.replace("{dataSource}", encodeURIComponent("" + dataSource));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalDataSourcesSetPriority,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigExternalDataSourcesSetPriority?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalDataSourcesSetPriority(_response);
    });
}

function processExternalDataSourcesSetPriority(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigExternalDataSourcesGetList: Partial<AxiosRequestConfig> | null;
export function getExternalDataSourcesGetListRequestConfig() {
  return _requestConfigExternalDataSourcesGetList;
}
export function setExternalDataSourcesGetListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesGetList = value;
}
export function patchExternalDataSourcesGetListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesGetList = patch(_requestConfigExternalDataSourcesGetList ?? {});
}

let _requestConfigExternalDataSourcesSetEnabled: Partial<AxiosRequestConfig> | null;
export function getExternalDataSourcesSetEnabledRequestConfig() {
  return _requestConfigExternalDataSourcesSetEnabled;
}
export function setExternalDataSourcesSetEnabledRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesSetEnabled = value;
}
export function patchExternalDataSourcesSetEnabledRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesSetEnabled = patch(_requestConfigExternalDataSourcesSetEnabled ?? {});
}

let _requestConfigExternalDataSourcesSetPriority: Partial<AxiosRequestConfig> | null;
export function getExternalDataSourcesSetPriorityRequestConfig() {
  return _requestConfigExternalDataSourcesSetPriority;
}
export function setExternalDataSourcesSetPriorityRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesSetPriority = value;
}
export function patchExternalDataSourcesSetPriorityRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalDataSourcesSetPriority = patch(_requestConfigExternalDataSourcesSetPriority ?? {});
}